import React from 'react';
import {
  Box,
  Card,
  CardContent,
  Grid,
  Stack,
  Typography,
} from '@mui/material';
import TimerIcon from '@mui/icons-material/Timer';
import SpeedIcon from '@mui/icons-material/Speed';
import EditNoteIcon from '@mui/icons-material/EditNote';
import PlayCircleFilledIcon from '@mui/icons-material/PlayCircleFilled';
import StopCircleIcon from '@mui/icons-material/StopCircle';
import { BRAND } from '../../theme/brandTheme';

/** Lifecycle KPI row — avg duration, velocity, pipeline counts */
const StatisticsLifecycleCards = ({ lifecycle }) => {
  if (!lifecycle) return null;

  const { avgTestDurationDays, testsWithDuration, testVelocity, draftTests, activeTests, stoppedTests } =
    lifecycle;
  const { created = 0, completed = 0, periodDays = 30 } = testVelocity || {};

  return (
    <Box sx={{ mb: 4 }}>
      <Typography variant="h6" sx={{ fontWeight: 700, color: BRAND.purple, mb: 2 }}>
        Test Yaşam Döngüsü
      </Typography>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6} md={3}>
          <Card sx={{ height: '100%', boxShadow: '0 2px 10px rgba(0,0,0,0.08)' }}>
            <CardContent>
              <Stack direction="row" justifyContent="space-between" alignItems="flex-start">
                <Box>
                  <Typography variant="h3" sx={{ fontWeight: 700, color: BRAND.purple }}>
                    {avgTestDurationDays}
                    <Typography component="span" variant="h6" sx={{ ml: 0.5 }}>
                      gün
                    </Typography>
                  </Typography>
                  <Typography variant="body1" color="text.secondary">
                    Ort. Test Süresi
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    {testsWithDuration} testte süre kaydı
                  </Typography>
                </Box>
                <TimerIcon sx={{ fontSize: 40, color: '#9B7EDE' }} />
              </Stack>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <Card sx={{ height: '100%', boxShadow: '0 2px 10px rgba(0,0,0,0.08)' }}>
            <CardContent>
              <Stack direction="row" justifyContent="space-between" alignItems="flex-start">
                <Box>
                  <Typography variant="h3" sx={{ fontWeight: 700, color: BRAND.green }}>
                    {created}
                  </Typography>
                  <Typography variant="body1" color="text.secondary">
                    Yeni Test ({periodDays}g)
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    Son {periodDays} günde oluşturulan
                  </Typography>
                </Box>
                <SpeedIcon sx={{ fontSize: 40, color: '#5ADC87' }} />
              </Stack>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <Card sx={{ height: '100%', boxShadow: '0 2px 10px rgba(0,0,0,0.08)' }}>
            <CardContent>
              <Stack direction="row" justifyContent="space-between" alignItems="flex-start">
                <Box>
                  <Typography variant="h3" sx={{ fontWeight: 700, color: '#2E74B5' }}>
                    {completed}
                  </Typography>
                  <Typography variant="body1" color="text.secondary">
                    Tamamlanan ({periodDays}g)
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    Durdurulmuş testler
                  </Typography>
                </Box>
                <StopCircleIcon sx={{ fontSize: 40, color: '#6588DF' }} />
              </Stack>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <Card sx={{ height: '100%', boxShadow: '0 2px 10px rgba(0,0,0,0.08)' }}>
            <CardContent>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5, fontWeight: 600 }}>
                Pipeline
              </Typography>
              <Stack spacing={1}>
                <Stack direction="row" alignItems="center" justifyContent="space-between">
                  <Stack direction="row" alignItems="center" spacing={0.5}>
                    <EditNoteIcon sx={{ fontSize: 18, color: '#F1C40F' }} />
                    <Typography variant="body2">Taslak</Typography>
                  </Stack>
                  <Typography variant="body2" sx={{ fontWeight: 700 }}>
                    {draftTests}
                  </Typography>
                </Stack>
                <Stack direction="row" alignItems="center" justifyContent="space-between">
                  <Stack direction="row" alignItems="center" spacing={0.5}>
                    <PlayCircleFilledIcon sx={{ fontSize: 18, color: BRAND.green }} />
                    <Typography variant="body2">Canlı</Typography>
                  </Stack>
                  <Typography variant="body2" sx={{ fontWeight: 700 }}>
                    {activeTests}
                  </Typography>
                </Stack>
                <Stack direction="row" alignItems="center" justifyContent="space-between">
                  <Stack direction="row" alignItems="center" spacing={0.5}>
                    <StopCircleIcon sx={{ fontSize: 18, color: '#95A5A6' }} />
                    <Typography variant="body2">Durduruldu</Typography>
                  </Stack>
                  <Typography variant="body2" sx={{ fontWeight: 700 }}>
                    {stoppedTests}
                  </Typography>
                </Stack>
              </Stack>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};

export default StatisticsLifecycleCards;
